// Contact / Custom-Made form: post-submit success polish.
//
// Why this is so small: Shopify's {% form 'contact' %} POSTs to /contact,
// which lives behind Cloudflare's bot challenge — fetch() submissions get
// 403'd, so AJAX is not viable. Native form submission works fine, and
// when the page template name starts with "page.contact" Shopify redirects
// back with ?contact_posted=true and Liquid renders <p class="form-success">
// inline. This script upgrades that bare <p> into the rich green banner
// (icon + heading + body + email fallback) that matches the brand UX.
(function () {
  const SELECTOR = 'form[data-contact-form]';

  function init() {
    document.querySelectorAll(SELECTOR + ' .form-success').forEach(upgradeNode);
  }

  function upgradeNode(node) {
    if (node.dataset.upgraded === '1') return;
    node.dataset.upgraded = '1';
    const form = node.closest('form');
    if (!form) return;

    const fieldsContainer = form.querySelector('.wpforms-field-container');
    const submitContainer = form.querySelector('.wpforms-submit-container');
    if (fieldsContainer) fieldsContainer.style.display = 'none';
    if (submitContainer) submitContainer.style.display = 'none';

    const upgraded = document.createElement('div');
    upgraded.className = 'form-success';
    upgraded.setAttribute('role', 'status');
    upgraded.innerHTML = [
      '<div class="form-success-icon" aria-hidden="true">',
      '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
      '</div>',
      '<h4 class="form-success-heading">Thank you</h4>',
      '<p class="form-success-message">We\'ve received your enquiry and will be in touch within 24 hours.</p>',
      '<p class="form-success-fallback">For urgent questions, email <a href="mailto:orders@houseofbariki.com.au">orders@houseofbariki.com.au</a>.</p>',
    ].join('');
    node.replaceWith(upgraded);

    upgraded.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
